<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="出厂编号：" prop="factory_code">
                <el-input v-model="model.factory_code"></el-input>
            </el-form-item>
            <el-form-item label="品牌：" prop="brand">
                <el-input v-model="model.brand"></el-input>
            </el-form-item>
            <el-form-item label="设备型号：" prop="device_code">
                <el-input v-model="model.device_code"></el-input>
            </el-form-item>
            <el-form-item label="物联网卡：" prop="net_card_id">
                <el-select v-model="model.net_card_id" placeholder="请选择" clearable filterable style="width: 100%">
                    <el-option v-for="item in netCardList" :key="item.id"  :label="item.card_code" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getNetCardList } from '@/api/deviceuser'

export default {
    name: 'routersEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                factory_code: '',
                brand: '',
                device_code: '',
                net_card_id: '',
                net_card_code: '',
                state: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/routers/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                factory_code: [
                    {required: true, message: '出厂编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                brand: [
                    {required: true, message: '品牌不能为空', trigger: 'blur'}
                ],
                device_code: [
                    {required: true, message: '设备型号不能为空', trigger: 'blur'}
                ],
            },
            checkObj:{
                url:'/api/admin/routers/check',
                data:{}
            },
            exits_p_name:'factory_code',
            exits_p_title:'出厂编号',
            netCardList: [],
        };
    },
    methods: {
        loadOtherData() {
            getNetCardList().then(res=>{
                if(res.code ==1){
                    this.netCardList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/routers/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>